import store from "../store";

/**/
var SET_DOCUMENT = "SET_DOCUMENT";
var BUILDER_MODE = "BUILDER_MODE";
var SET_VIEW = "SET_VIEW";
var REMOVE_VIEW = "REMOVE_VIEW";
var ADD_LINE = "ADD_LINE";
var REMOVE_LINE = "REMOVE_LINE";
var MOVE_LINE = "MOVE_LINE";
var DRAG_END_VIEW = "DRAG_END_VIEW";
/**/
export function setDocument(document: any) {
  store.dispatch({
    type: SET_DOCUMENT,
    document,
  });
}
export function builderMode(builder: boolean) {
  store.dispatch({
    type: BUILDER_MODE,
    builder,
  });
}
export async function setView(path: string, value: string | number | object) {
  store.dispatch({
    type: SET_VIEW,
    path,
    value,
  });
}
export function removeView(path: string) {
  store.dispatch({
    type: REMOVE_VIEW,
    path,
  });
}
export function dragEndView(result: any) {
  store.dispatch({
    type: DRAG_END_VIEW,
    result,
  });
}

export function addLine(order: number) {
  store.dispatch({
    type: ADD_LINE,
    order,
  });
}
export function removeLine(order: number) {
  store.dispatch({
    type: REMOVE_LINE,
    order,
  });
}
export function moveLine(order: number, number: number) {
  store.dispatch({
    type: MOVE_LINE,
    order,
    move_order: order + number,
  });
}
